/*
 * @Author: huangzq
 * @Date: 2019-12-30 17:34:41
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-07-23 16:10:42
 * @Desc: 预览和设置弹窗
*/
<template>
  <div class="preview-set">
    <mk-drawer-biz-two
      :visible="visible"
      :append-to-body="false"
      size="810px"
      with-preview
      @open="onOpen"
      @close="onClose"
    >
      <template v-slot:title>
        <set-title
          :set-type.sync="setType"
          :set-list="setList"
        />
      </template>

      <component
        :is="setType"
        :material-data="cloneMaterialData"
        @on-iframe-data="iframePostDataMessage"
        @on-iframe-event="iframePostEventMessage"
      />

      <template v-slot:bottom>
        <mk-button-biz @click="onClose">
          取 消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          :loading="btnLoading"
          @click="onConfirm"
        >
          保存设置
        </mk-button-biz>
      </template>

      <template v-slot:preview>
        <preview
          :preview-data="previewData"
          :show-prev-and-next="false"
          @iframe-loaded="iframeLoaded"
        />
        <bottom-swiper
          :material-data="cloneMaterialData"
          @on-click="bottomSwiperOnClick"
        />
      </template>
    </mk-drawer-biz-two>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import SetTitle from './components/set-title'
import BasicSet from './components/basic-set'
import HighSet from './components/high-set'
import Preview from '../preview'

import BottomSwiper from '../preview/bottom-swiper'

export default {
  name: 'PreviewSet',
  components: {
    MkDrawerBizTwo,
    SetTitle,
    BasicSet,
    HighSet,
    Preview,
    BottomSwiper
  },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },

    // 资料数据
    materialData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 设置的类型：基础设置(basic-set)、高级设置(high-set)
      setType: '',
      // 设置类型 列表
      setList: [
        {
          type: 'basic-set',
          title: '基础设置'
        },
        {
          type: 'high-set',
          title: '高级设置'
        }
      ],
      cloneMaterialData: {},
      // 保存按钮是否loading
      btnLoading: false,
      // 预览数据
      previewData: { linkUrl: '' },
      // iframe加载完成后，返回的iframe的Dom元素
      previewIframeDom: null
    }
  },
  methods: {

    // 弹窗-取消按钮事件：关闭预览和设置弹窗
    onClose () {
      if (this.visible) {
        this.$emit('update:visible', false)
      }
    },
    // 弹窗打开时，赋值最新的营销资料的数据
    onOpen () {
      this.previewIframeDom = null
      this.btnLoading = false
      this.cloneMaterialData = this._.cloneDeep(this.materialData)
      this.cloneMaterialData.isShowQRCode = Boolean(this.cloneMaterialData.contactOpt)

      const { rules } = this.cloneMaterialData

      this.setType = this.setList[0].type
      this.createIframeSrc()
    },

    // 生成iframe的src
    async createIframeSrc () {
      let { linkUrl } = await this.util.createH5Url(this.cloneMaterialData, 'brochure', this.$projectScene, true)
      linkUrl += '&iframeData=yes'
      this.previewData.linkUrl = linkUrl
    },
    // iframe加载完毕后的处理
    iframeLoaded (previewIframeDom) {
      this.previewIframeDom = previewIframeDom
      this.iframePostDataMessage()
    },

    // 通过iframe进行【值】传值
    iframePostDataMessage () {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'data',
        postData: this.cloneMaterialData
      }, this.previewData.linkUrl)
    },

    // 通过iframe进行【事件】传递
    iframePostEventMessage (eventName, eventParams = {}) {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'event',
        postData: { eventName, eventParams }
      }, this.previewData.linkUrl)
    },

    // 底部缩略栏点击事件
    bottomSwiperOnClick (index) {
      this.iframePostEventMessage('toPage', {
        index
      })
    },

    // 弹窗-确定按钮事件：关闭弹窗，然后将数据返回上一层
    onConfirm () {
      if (this.cloneMaterialData.title) {
        if (this.util.checkTagRules(this.cloneMaterialData.rules)) {
          this.btnLoading = true
          this.$emit('on-confirm', this.cloneMaterialData)
        } else {
          this.setType = 'high-set'
          this.$message.error('请为每一条标签规则 选择标签')
        }
      } else {
        this.$message.error('请输入标题')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-set {
  & /deep/ .el-form {
    .el-form-item__label {
      font-weight: 500;
    }
  }
}
</style>
